<template>
  <a-modal
    :open="props.open"
    centered
    class="consultation-request-success-modal"
    @update:open="emit('update:open', $event)"
    width="400"
  >
    <div class="consultation-request-success-modal__icon-box">
      <img :src="`${ICONS_BASE}/ok.svg`" alt="" />
    </div>

    <h3 class="consultation-request-success-modal__title">{{ props.title }}</h3>

    <p class="consultation-request-success-modal__description">
      {{ displayDescription }}
    </p>

    <template #footer>
      <button
        class="btn btn-outline consultation-request-success-modal__action"
        type="button"
        @click="onContinue"
      >
        {{ props.continueLabel }}
      </button>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const DEFAULT_DESCRIPTION =
  'Спасибо! Мы получили Ваше обращение и рассмотрим его в ближайшее время.';

const props = withDefaults(
  defineProps<{
    open: boolean;
    title?: string;
    description?: string;
    continueLabel?: string;
    onContinue?: () => void;
  }>(),
  {
    title: 'Заявка отправлена',
    description: '',
    continueLabel: 'Продолжить',
  },
);

const displayDescription = computed(() => {
  const fromApi = props.description?.trim();
  return fromApi || DEFAULT_DESCRIPTION;
});

const emit = defineEmits<{
  'update:open': [value: boolean];
}>();

const onContinue = () => {
  emit('update:open', false);

  props.onContinue?.();
};
</script>

<style>
.consultation-request-success-modal {
  width: 400px !important;

  @media (max-width: 576px) {
    width: 100% !important;
  }
}

.consultation-request-success-modal .ant-modal-content {
  padding-bottom: 20px;
  border-radius: var(--stc-border-radius-md);
  width: 400px;

  @media (max-width: 576px) {
    width: 100%;
  }
}

.consultation-request-success-modal .ant-modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 44px 0px 35px;
}

.ant-modal-body .consultation-request-success-modal__title {
  margin: 0;
  margin-top: 22px;
  font-family: var(--stc-font-semibold);
  font-weight: 600;
  font-size: 20px;
  line-height: 1.6;
  letter-spacing: 0%;
  color: var(--stc-black);
}

.consultation-request-success-modal__icon-box {
  width: 80px;
  height: 80px;
  background-color: var(--stc-brand-600);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.consultation-request-success-modal__description {
  margin-top: 1px;
  padding: 0 24px;
  font-size: 12px;
  color: var(--stc-gray-400);
  text-align: center;
}

.consultation-request-success-modal .ant-modal-footer {
  margin-top: 0;
  padding-bottom: 44px;
}

.consultation-request-success-modal .consultation-request-success-modal__action {
  display: block;
  height: 40px;
  line-height: 1;
  font-size: 14px;
  padding: 12px 16px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;
}
</style>
